import { createClient } from '@supabase/supabase-js';

export const clientSide = () => {
  const supabase = createClient(
    process.env['NEXT_PUBLIC_SUPABASE_URL']!,
    process.env['NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY']!
  );
  return supabase;
};
